import { AudienceAidesHub } from '../../../components/aides/AudienceAidesHub';
import { AIDES_ENTREPRISES } from '../../../config/aides-entreprises';

export default function EntreprisesAidesPage() {
  return (
    <AudienceAidesHub
      audienceId="entreprises"
      aides={AIDES_ENTREPRISES}
      heroEyebrow="Panorama 2026 · 7 leviers cumulables"
      heroHeadline="Toutes vos aides"
      heroHeadlineAccent="multi-sites cumulables."
      heroIntro="ETI et grands comptes : primes CEE tertiaires et industrielles, Fonds chaleur ADEME, Fonds décarbonation industrie (Plan France 2030), suramortissement fiscal — plus deux leviers directs sur la facture : l'optimisation du tarif d'acheminement réseau (TURPE) et l'exonération de la contribution au service public de l'électricité (CSPE) pour les sites très consommateurs d'électricité. Le cumul de ces dispositifs peut faire fortement baisser le coût net de vos investissements énergétiques."
      primaryCta={{ label: 'Lancer le diagnostic primes énergie', href: '/entreprises/diagnostic-cee' }}
      secondaryCta={{ label: 'Comparateur énergie multi-sites', href: '/entreprises/comparateur-energie' }}
      bullets={['Sources réglementaires citées', 'Accord de confidentialité disponible', 'Référent grands comptes dédié']}
      gridEyebrow="7 leviers cumulables"
      gridTitle="Les leviers d'aide pour ETI & grands comptes"
      ctaFinalTitle="Quels leviers pour votre patrimoine ?"
      ctaFinalDescription="Diagnostic SIRET multi-sites · Plan d'aides chiffré exploitable pour votre comité énergie / RSE."
    />
  );
}
